import { combineReducers } from 'redux'

import jobs from './jobs/reducers'

const employerReducer = combineReducers({
  jobs,
})

export default employerReducer
